// This file is automatically generated. Do not edit manually.

import { SalesLeadToOfferService_NewCustomerData } from "src/api/generated/erp/sales/crm/salesLeads/service/salesLeadToOfferService";
import { CustomerOrderOffer } from "src/api/generated/erp/db/types/tables/customerOrderOffer";
import { SalesLeadToOfferService_Result } from "src/api/generated/erp/sales/crm/salesLeads/service/salesLeadToOfferService";
import { ContractualTerm } from "src/api/generated/erp/db/types/tables/contractualTerm";
import { Currency } from "src/api/generated/erp/db/types/tables/currency";
import { CustomerAddress } from "src/api/generated/erp/db/types/tables/customerAddress";
import { CustomerGroup } from "src/api/generated/erp/db/types/tables/customerGroup";
import { CustomerOfferType } from "src/api/generated/erp/db/types/tables/customerOfferType";
import { CustomerPriceGroup } from "src/api/generated/erp/db/types/tables/customerPriceGroup";
import { DeliveryMethod } from "src/api/generated/erp/db/types/tables/deliveryMethod";
import { DeliveryTerm } from "src/api/generated/erp/db/types/tables/deliveryTerm";
import { EInvoiceOperator } from "src/api/generated/erp/db/types/tables/eInvoiceOperator";
import { PaymentTerm } from "src/api/generated/erp/db/types/tables/paymentTerm";
import { SalesLead } from "src/api/generated/erp/db/types/tables/salesLead";
import { Contact } from "src/api/generated/erp/db/types/tables/contact";
import { SalespersonView } from "src/api/generated/erp/db/types/tables/salespersonView";
import { Site } from "src/api/generated/erp/db/types/tables/site";
import { TransportRoute } from "src/api/generated/erp/db/types/tables/transportRoute";
import { VatCode } from "src/api/generated/erp/db/types/tables/vatCode";
import { VatHandlingType } from "src/api/generated/erp/db/types/tables/vatHandlingType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SalesLeadToOfferApi {
	export async function getInitData(args: { salesLeadId: number }): Promise<SalesLeadToOfferApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/salesLeadToOffer/getInitData",
			method: "POST",
			data: {
				salesLeadId: args.salesLeadId,
			},
		});
		return response as SalesLeadToOfferApi_InitData;
	}

	export async function submit(args: {
		salesLeadId: number;
		newCustomerData: SalesLeadToOfferService_NewCustomerData | null | undefined;
		customerOffer: CustomerOrderOffer;
	}): Promise<SalesLeadToOfferService_Result> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/salesLeadToOffer/submit",
			method: "POST",
			data: {
				salesLeadId: args.salesLeadId,
				newCustomerData: args.newCustomerData,
				customerOffer: args.customerOffer,
			},
		});
		return response as SalesLeadToOfferService_Result;
	}
}

export interface SalesLeadToOfferApi_InitData {
	contractualTermOptions: Array<ContractualTerm>;
	currencyOptions: Array<Currency>;
	customerAddresses: Array<CustomerAddress> | null | undefined;
	customerCurrencyId: number | null | undefined;
	customerGroupOptions: Array<CustomerGroup>;
	customerOfferTypeOptions: Array<CustomerOfferType>;
	customerPriceGroupOptions: Array<CustomerPriceGroup>;
	deliveryMethodOptions: Array<DeliveryMethod>;
	deliveryTermOptions: Array<DeliveryTerm>;
	eInvoiceOperatorOptions: Array<EInvoiceOperator>;
	paymentTermOptions: Array<PaymentTerm>;
	salesLead: SalesLead;
	salesLeadContacts: Array<Contact>;
	salespersonOptions: Array<SalespersonView>;
	siteOptions: Array<Site>;
	transportRouteOptions: Array<TransportRoute>;
	vatCodeOptions: Array<VatCode>;
	vatHandlingTypeOptions: Array<VatHandlingType>;
}
